// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1kNwo","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1ncH_"};